import styled, { keyframes } from 'styled-components';
const spinAnimation = keyframes `
  0% {
    transform: rotate(0);
  }
  10% {
    transform: rotate(40deg);
  }
  24% {
    transform: rotate(80deg);
  }
  29% {
    transform: rotate(220deg);
  }
  48% {
    transform: rotate(720deg);
  }
  52% {
    transform: rotate(725deg);
  }
  58% {
    transform: rotate(715deg);
  }
  76% {
    transform: rotate(720deg);
  }
  100% {
    transform: rotate(720deg);
  }
`;
export const Icon = styled.svg `
  height: 5.4rem;
  width: 5.4rem;
  animation-duration: 2.2s;
  animation-name: ${spinAnimation};
  animation-timing-function: linear;
  animation-iteration-count: infinite;
`;
export const Wrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
